"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMore = void 0;
var React = __importStar(require("react"));
var IconMore = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12.70725,12.00025 L19.85325,4.85425 C20.04925,4.65825 20.04925,4.34225 19.85325,4.14625 C19.65825,3.95125 19.34225,3.95125 19.14625,4.14625 L12.00025,11.29325 L4.85325,4.14625 C4.65825,3.95125 4.34225,3.95125 4.14625,4.14625 C3.95125,4.34225 3.95125,4.65825 4.14625,4.85425 L11.29325,12.00025 L4.14625,19.14625 C3.95125,19.34225 3.95125,19.65825 4.14625,19.85425 C4.24425,19.95125 4.37225,20.00025 4.50025,20.00025 C4.62825,20.00025 4.75625,19.95125 4.85325,19.85425 L12.00025,12.70725 L19.14625,19.85425 C19.24425,19.95125 19.37225,20.00025 19.50025,20.00025 C19.62825,20.00025 19.75625,19.95125 19.85325,19.85425 C20.04925,19.65825 20.04925,19.34225 19.85325,19.14625 L12.70725,12.00025 Z", transform: "rotate(45 12 12)" }))); };
exports.IconMore = IconMore;
exports.IconMore.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconMore;
